<template>
    <div>
        <div id="jobcard">
        <v-dialog
            :width="dataLoaded ? 1150 : 500"
            v-model="display"
            scrollable="">
            <v-card v-if="!dataLoaded">
                <v-card-text>
                    <div class="text-center mt-6">
                        <v-progress-circular
                            indeterminate
                            v-if="!dataLoaded"
                            color="primary">
                        </v-progress-circular>
                    </div>
                </v-card-text>
            </v-card>
            <v-card
                flat
                v-if="dataLoaded">
                <v-card-title>
                    {{ $t("JOBCARD_PAGE_TITLE") }}
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="jobcard.state == 'CLOSED' && authorizations.jobcards.reopen"
                        icon
                        @click=" openJobcardFinalReopenDialog(jobcard.id)">
                        <v-icon>mdi-door-open</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="!!jobcard.leave_date && authorizations.jobcards.close"
                        icon
                        color="error"
                        @click="openJobcardFinalCloseDialog(jobcard.id)"
                        :disabled="jobcard.state == 'CLOSED'">
                        <v-icon>mdi-power</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="!jobcard.leave_date"
                        icon
                        color="success"
                        @click="openJobcardCloseDialog({id: jobcard.id})"
                        :disabled="jobcard.state == 'CLOSED'">
                        <v-icon>mdi-truck-check</v-icon>
                    </v-btn>
                    <v-divider vertical class="ml-2"></v-divider>
                    <v-btn
                        icon
                        :loading="loading.refresh"
                        @click="loading.refresh = true; createdDataFetch()">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        @click="print">
                        <v-icon>mdi-printer</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>
                    {{ $t("JOBCARD_PAGE_SUBTITLE") }}
                </v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text v-if="dataLoaded">
                    <v-subheader>
                        {{ $t("JOBCARD_PAGE_BASIC_INFO") }}
                    </v-subheader>

                    <v-row>
                        <v-col>
                            <v-simple-table dense="">
                                <tbody>
                                    <tr>
                                        <th>{{ $t("JOBCARDS_CODE") }}</th>
                                        <td>{{ jobcard.the_code }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("JOBCARDS_PLATE") }}</th>
                                        <td>
                                            {{ jobcard.plate_number }}
                                            <v-menu
                                                absolute=""
                                                :close-on-content-click="false"
                                                transition="scroll-y-transition"
                                                dark>
                                                <template v-slot:activator="{on}">
                                                    <v-btn
                                                        v-on="on"
                                                        icon
                                                        depressed
                                                        x-small
                                                        class="mr-2"
                                                        color="info">
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                </template>
                                                <TruckDisplayMenu
                                                    :truck-id="jobcard.truck_id"/>
                                            </v-menu>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("JOBCARD_DRIVER") }}</th>
                                        <td>
                                            {{ jobcard.driver_name }}
                                            <v-menu
                                                absolute=""
                                                :close-on-content-click="false"
                                                transition="scroll-y-transition"
                                                dark>
                                                <template v-slot:activator="{on}">
                                                    <v-btn
                                                        v-on="on"
                                                        icon
                                                        depressed
                                                        x-small
                                                        class="mr-2"
                                                        color="info">
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                </template>
                                                <DriverDisplayMenu
                                                    :driver-id="jobcard.driver_id"/>
                                            </v-menu>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("JOBCARDS_STATE") }}</th>
                                        <td>{{ jobcard.state }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("JOBCARD_ODOMETER") }}</th>
                                        <td>{{ jobcard.odometer }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                        <v-col>
                            <v-simple-table dense="">
                                <tbody>
                                    <tr>
                                        <th>{{ $t("JOBCARDS_DATE_ENTER") }}</th>
                                        <td>{{ jobcard.date_enter }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("JOBCARD_TIME_ENTER") }}</th>
                                        <td>{{ jobcard.time_enter }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("JOBCARDS_TRUCK_TYPE") }}</th>
                                        <td>{{ jobcard.truck_type }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("JOBCARDS_WORKSHOP") }}</th>
                                        <td>{{ jobcard.workshop }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("JOBCARDS_DATE_LEAVE") }}</th>
                                        <td>{{ jobcard.leave_date }}</td>
                                    </tr>
                                    <tr>
                                        <th>{{ $t("JOBCARD_TIME_LEAVE") }}</th>
                                        <td>{{ jobcard.leave_time }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>

                    <v-divider></v-divider>

                    <v-card
                        flat
                        >
                        <v-card-subtitle>
                            {{ $t("JOBCARD_PAGE_FAILURE_SUBTITLE") }}
                        </v-card-subtitle>
                        
                        <v-card-text>
                            <v-simple-table 
                                dense
                                >
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_DESCRIPTION") }}</th>
                                        <th>{{ $t("ACTIONS_MENU_TITLE") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(failure, index) in jobcardFailures" :key="index">
                                        <td>{{index + 1}}</td>
                                        <td>{{failure.description}}</td>
                                        <td>
                                            <v-menu>
                                                <template v-slot:activator="{on}">
                                                    <v-btn
                                                        icon
                                                        small
                                                        v-on="on">
                                                        <v-icon>mdi-dots-horizontal</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-card>
                                                    <v-subheader>{{ $t("ACTIONS_MENU_TITLE") }}</v-subheader>
                                                    <v-list dense>
                                                        <v-list-item
                                                            link
                                                            @click="openJobcardFailureDialog({editMode: true, id: failure.id})"
                                                            :disabled="!failure.meta.editable">
                                                            <v-list-item-avatar>
                                                                <v-icon :disabled="!failure.meta.editable">mdi-pencil</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ $t("ACTIONS_MENU_EDIT") }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item
                                                            link
                                                            @click="openDeleteJobcardFailureDialog(failure.id)"
                                                            :disabled="!failure.meta.deletable">
                                                            <v-list-item-avatar>
                                                                <v-icon :disabled="!failure.meta.deletable">mdi-delete</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ $t("ACTIONS_MENU_DELETE") }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-card>
                                            </v-menu>
                                        </td>
                                </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                icon
                                :disabled="jobcard.state == 'CLOSED'"
                                @click="openJobcardFailureDialog({editMode: false, jobcard_id: jobcard.id})">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-card
                        flat
                        >
                        <v-card-subtitle>{{ $t("JOBCARD_PAGE_MAINT_SUBTITLE") }}</v-card-subtitle>
                        <v-card-text>
                            <v-simple-table dense="">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_DESCRIPTION") }}</th>
                                        <th>{{ $t("GROUP") }}</th>
                                        <th>{{ $t("ACTIONS_MENU_TITLE") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(maintenance, index) in jobcardMaintenances" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ maintenance.description }}</td>
                                        <td>{{ maintenance.malfaction }}</td>
                                        <td>
                                            <v-menu>
                                                <template v-slot:activator="{on}">
                                                    <v-btn
                                                        icon
                                                        small
                                                        v-on="on">
                                                        <v-icon>mdi-dots-horizontal</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-card>
                                                    <v-subheader>{{ $t("ACTIONS_MENU_TITLE") }}</v-subheader>
                                                    <v-list dense>
                                                        <v-list-item
                                                            link
                                                            @click="openJobcardMaintenanceDialog({editMode: true, id: maintenance.id})"
                                                            :disabled="!maintenance.meta.editable">
                                                            <v-list-item-avatar>
                                                                <v-icon :disabled="!maintenance.meta.editable">mdi-pencil</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ $t("ACTIONS_MENU_EDIT") }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item
                                                            link
                                                            @click="openDeleteJobcardMaintenanceDialog(maintenance.id)"
                                                            :disabled="!maintenance.meta.deletable">
                                                            <v-list-item-avatar>
                                                                <v-icon :disabled="!maintenance.meta.deletable">mdi-delete</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ $t("ACTIONS_MENU_DELETE") }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-card>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                icon
                                :disabled="jobcard.state == 'CLOSED'"
                                @click="openJobcardMaintenanceDialog({editMode: false, jobcard_id: jobcard.id})">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>

                    <v-divider></v-divider>

                    <v-card
                        flat
                        >
                        <v-card-subtitle>{{ $t("JOBCARD_PAGE_SPAREPART_SUBTITLE") }}</v-card-subtitle>
                        <v-card-text>
                            <v-simple-table dense="">
                                <thead >
                                    <tr>
                                        <th>#</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_DESCRIPTION") }}</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_QTY") }}</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_PRICE") }}</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_TOTAL") }}</th>
                                        <th>{{ $t("ACTIONS_MENU_TITLE") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(spare, index) in jobcardSpares" :key="index">
                                        <td>{{ index+1 }}</td>
                                        <td>{{ spare.item_info.name }}</td>
                                        <td>{{ spare.quantity }}</td>
                                        <td>{{ spare.price }}</td>
                                        <td>{{ spare.quantity * spare.price }}</td>
                                        <td>
                                            <v-menu>
                                                <template v-slot:activator="{on}">
                                                    <v-btn
                                                        icon
                                                        small
                                                        v-on="on">
                                                        <v-icon>mdi-dots-horizontal</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-card>
                                                    <v-subheader>{{ $t("ACTIONS_MENU_TITLE") }}</v-subheader>
                                                    <v-list dense>
                                                        <v-list-item
                                                            link
                                                            @click="openJobcardSpareDialog({editMode: true, id: spare.id })"
                                                            :disabled="!spare.meta.editable">
                                                            <v-list-item-avatar>
                                                                <v-icon :disabled="!spare.meta.editable">mdi-pencil</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ $t("ACTIONS_MENU_EDIT") }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item
                                                            link
                                                            @click="openDeleteJobcardSpareDialog(spare.id)"
                                                            :disabled="!spare.meta.deletable">
                                                            <v-list-item-avatar>
                                                                <v-icon :disabled="!spare.meta.deletable">mdi-delete</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ $t("ACTIONS_MENU_DELETE") }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-card>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                icon
                                @click="openJobcardSpareDialog({editMode: false, jobcard_id: jobcard.id})"
                                :disabled="jobcard.state == 'CLOSED'">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-divider></v-divider>
                    <v-card flat>
                        <v-card-subtitle>
                            {{ $t("JOBCARD_PAGE_EXTERNAL_MAINT_SUBTITLE") }}
                        </v-card-subtitle>
                        <v-card-text>
                            <v-simple-table dense="">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>{{ $t("JOBCARD_EXTERN_WORKSHOP") }}</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_DESCRIPTION") }}</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_QTY") }}</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_PRICE") }}</th>
                                        <th>{{ $t("JOBCARD_PAGE_TABLE_TOTAL") }}</th>
                                        <th>{{ $t("JOBCARDS_ACTIONS") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(external_maintenance, index) in jobcardExternalMaintenances" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ external_maintenance.external_workshop }}</td>
                                        <td>{{ external_maintenance.description }}</td>
                                        <td>{{ external_maintenance.quantity }}</td>
                                        <td>{{ external_maintenance.price }}</td>
                                        <td>{{ external_maintenance.quantity * external_maintenance.price }}</td>
                                        <td>
                                            <v-menu>
                                                <template v-slot:activator="{on}">
                                                    <v-btn
                                                        icon
                                                        small
                                                        v-on="on">
                                                        <v-icon>mdi-dots-horizontal</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-card>
                                                    <v-subheader>{{ $t("JOBCARDS_ACTIONS") }}</v-subheader>
                                                    <v-list dense>
                                                        <v-list-item
                                                            link
                                                            @click="openJobcardExternalMaintenanceDialog({editMode: true, jobcard_id: null, id: external_maintenance.id})"
                                                            :disabled="!external_maintenance.meta.editable">
                                                            <v-list-item-avatar>
                                                                <v-icon :disabled="!external_maintenance.meta.editable">mdi-pencil</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ $t("ACTIONS_MENU_EDIT") }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                        <v-list-item
                                                            link
                                                            @click="openJobcardExternalMaintenanceDeleteDialog(external_maintenance.id)"
                                                            :disabled="!external_maintenance.meta.deletable">
                                                            <v-list-item-avatar>
                                                                <v-icon :disabled="!external_maintenance.meta.deletable">mdi-delete</v-icon>
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{ $t("ACTIONS_MENU_DELETE") }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-card>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                icon
                                @click="openJobcardExternalMaintenanceDialog({editMode: false, jobcard_id: jobcard.id})"
                                :disabled="jobcard.state == 'CLOSED'">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-card>   
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        @click="close">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        </div>
        <JobcardFailureDialog
            ref="jobcardFailureDialog"/>
        <DecisionDialog
            ref="decisionDialog"
            @submit="submitDecisionDialog"/>
        <AlertDialog
            ref="alertDialog"/>
        <JobcardMaintenanceDialog
            ref="jobcardMaintenanceDialog"/>
        <JobcardSpareDialog
            ref="jobcardSpareDialog"/>
        <JobcardExternalMaintenanceDialog 
            ref="jobcardExternalMaintenanceDialog"/>
        <JobcardCloseDialog
            ref="jobcardCloseDialog"/>
        <JobcardPrintDialog
            ref="jobcardPrintDialog"
            :jobcard="jobcard"
            :jobcardFailures="jobcardFailures"
            :jobcardMaintenances="jobcardMaintenances"
            :jobcardSpares="jobcardSpares"
            :jobcardExternalMaintenances="jobcardExternalMaintenances"/>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
    </div>
</template>

<script>
import JobcardFailureDialog from '../components/JobcardFailureDialog';
import JobcardMaintenanceDialog from '../components/JobcardMaintenanceDialog';
import JobcardSpareDialog from "../components/JobcardSpareDialog"
import DecisionDialog from '../components/DecisionDialog';
import AlertDialog from '../components/AlertDialog';
import JobcardExternalMaintenanceDialog from "../components/jobcardExternalMaintenanceDialog";
import JobcardCloseDialog from "../components/JobcardCloseDialog";
import DriverDisplayMenu from '../components/DriverDisplayMenu';
import TruckDisplayMenu from '../components/TruckDisplayMenu';
import JobcardPrintDialog from '../components/JobcardPrintDialog';
import RetryDialog from '../components/RetryDialog';
import { mapActions, mapState } from 'vuex';

export default {
    name: "JobcardDisplayDialog",
    components: {
        JobcardFailureDialog,
        DecisionDialog,
        AlertDialog,
        JobcardMaintenanceDialog,
        JobcardSpareDialog,
        JobcardExternalMaintenanceDialog,
        JobcardCloseDialog,
        DriverDisplayMenu,
        TruckDisplayMenu,
        JobcardPrintDialog,
        RetryDialog
    },
    data() {
        return {
            display: false,
            dataLoaded: false,
            loading: {
                refresh: false
            },
            params: null
        }
    },
    computed: {
        ...mapState("jobcard", ["jobcard"]),
        ...mapState("jobcardFailure", ["jobcardFailures"]),
        ...mapState("jobcardMaintenance", ["jobcardMaintenances"]),
        ...mapState("jobcardSpare", ["jobcardSpares"]),
        ...mapState("jobcardExternalMaintenance", ["jobcardExternalMaintenances"]),
        ...mapState("authentication", ["loggedInUser", "authorizations"])
    },
    methods: {
        ...mapActions("jobcard", ["fetchJobcard", "jobcardFinalClose", "jobcardReopen"]),
        ...mapActions("jobcardFailure", ["fetchJobcardFailures", "removeJobcardFailure"]),
        ...mapActions("jobcardMaintenance", ["fetchJobcardMaintenances", "removeJobcardMaintenance"]),
        ...mapActions("jobcardSpare", ["fetchJobcardSpares", "removeJobcardSpare"]),
        ...mapActions("jobcardExternalMaintenance", ["fetchJobcardExternalMaintenances", "removeJobcardExternalMaintenance"]),
        openJobcardFailureDialog(params) {
            this.$refs.jobcardFailureDialog.open(params);
        },
        openJobcardMaintenanceDialog(params) {
            this.$refs.jobcardMaintenanceDialog.open(params);
        },
        openJobcardSpareDialog(params){
            this.$refs.jobcardSpareDialog.open(params);
        },
        openJobcardExternalMaintenanceDialog(params) {
            this.$refs.jobcardExternalMaintenanceDialog.open(params);
        },
        openJobcardCloseDialog(params) {
            this.$refs.jobcardCloseDialog.open(params);
        },
        openJobcardFinalCloseDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t("JOBCARD_CLOSE_TITLE"),
                content: this.$t("JOBCARD_CLOSE_CONTENT"),
                action: "JOBCARD_FINAL_CLOSE",
                id: id
            })
        },
        openJobcardFinalReopenDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t('JOBCARD_REOPEN_TITLE'),
                 content: this.$t("JOBCARD_REOPEN_CONTENT"),
                action: "JOBCARD_FINAL_REOPEN",
                id: id
            })
        },
        openDeleteJobcardFailureDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t("DELETE_CONFIRM_TITLE"),
                content: this.$t("DELETE_CONFIRM_CONTENT"),
                action: "DELETE_JOBCARD_FAILURE",
                id: id
            });
        },
        openDeleteJobcardMaintenanceDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t("DELETE_CONFIRM_TITLE"),
                content: this.$t("DELETE_CONFIRM_CONTENT"),
                action: "DELETE_JOBCARD_MAINTENANCE",
                id: id
            });
        },
        openDeleteJobcardSpareDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t("DELETE_CONFIRM_TITLE"),
                content: this.$t("DELETE_CONFIRM_CONTENT"),
                action: "DELETE_JOBCARD_SPARE",
                id: id
            });
        }, 
        openJobcardExternalMaintenanceDeleteDialog(id) {
            this.$refs.decisionDialog.open({
                title: this.$t("DELETE_CONFIRM_TITLE"),
                content: this.$t("DELETE_CONFIRM_CONTENT"),
                action: "DELETE_JOBCARD_EXTERNAL_MAINTENANCE",
                id: id
            });
        },
        submitDecisionDialog(payload) {
            if(payload.action == "DELETE_JOBCARD_FAILURE") {
                this.removeJobcardFailure(payload.id)
                    .then(response => {
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchJobcardFailures(this.jobcard.id);
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            } else if(payload.action == "DELETE_JOBCARD_MAINTENANCE") {
                this.removeJobcardMaintenance(payload.id)
                    .then(response => {
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchJobcardMaintenances(this.jobcard.id);
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            } else if (payload.action == "DELETE_JOBCARD_SPARE") {
                this.removeJobcardSpare(payload.id)
                    .then(response => {
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchJobcardSpares(this.jobcard.id);
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            } else if (payload.action == "DELETE_JOBCARD_EXTERNAL_MAINTENANCE") {
                this.removeJobcardExternalMaintenance(payload.id)
                    .then(response => {
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.fetchJobcardExternalMaintenances(this.jobcard.id);
                    })
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    });
            } else if (payload.action == "JOBCARD_FINAL_CLOSE") {
                this.jobcardFinalClose(payload.id)
                    .then(async response => {
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), response.message);
                        this.createdDataFetch();
                    }) 
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            } else if (payload.action == "JOBCARD_FINAL_REOPEN") {
                this.jobcardReopen(payload.id)
                    .then(() => {
                        this.$refs.alertDialog.open(this.$t("SUCCESS_TITLE"), this.$t('MSG_SUCCESS_REOPEN'));
                        this.createdDataFetch();
                    }) 
                    .catch(error => {
                        this.$refs.alertDialog.open(this.$t("ERROR_TITLE"), error.message);
                    })
            } 
        },
        print() {
            this.$refs.jobcardPrintDialog.open();
        },
        open(params) {
            this.params = params;
            this.dataLoaded = false;
            this.display = true;
            this.createdDataFetch();
        },
        close() {
            this.display = false;
        },
        async createdDataFetch() {
            try {
                await Promise.all([
                    this.fetchJobcard(this.params.id),
                    this.fetchJobcardFailures(this.params.id),
                    this.fetchJobcardMaintenances(this.params.id),
                    this.fetchJobcardSpares(this.params.id),
                    this.fetchJobcardExternalMaintenances(this.params.id),
                ]);
                this.dataLoaded = true;
                this.loading.refresh = false;
            } catch (error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "createdDataFetch", message});
                this.loading.refresh = false;
            } 
        },
        onRetryDialogSubmit(params) {
            if(params.target == "createdDataFetch") {
                if(params.retry == true) this.createdDataFetch();
            }
        }
    }
}
</script>